(function()
{
	var Application = include("springroll.Application");
	var Debug = include("springroll.Debug", false);
	var DebugOptions = include("nature.DebugOptions");
	var Powerup = include("nature.enum.Powerup");
	var RandomList = include("springroll.RandomList");

	var _powerupTime;
	var _powerupSegments;
	var _powerupsList;
	var _countdownTime;
	var _countdownPaused;

	/**
	 * Any object in the world
	 * @class PowerupManager
	 * @constructor
	 * @param {Object} config the app config
	 */
	var PowerupManager = function()
	{
		var config = Application.instance.config;
		_powerupTime = config.params.powerupTime;
		_powerupSegments = config.powerupSegments;

		_powerupsList = new RandomList([Powerup.Hal, Powerup.Shield, Powerup.Life]);

		_countdownTime = 0;
		_countdownPaused = true;

		this.startCountdown(30000);
	};

	var p = PowerupManager.prototype;

	p.startCountdown = function(countdownTime)
	{
		if (DebugOptions.powerup)
		{
			_countdownTime = 3000;
		}
		else if (countdownTime)
		{
			_countdownTime = countdownTime;
		}
		else
		{
			_countdownTime = [8000, 1000, 15000, 20000].random();
		}
		_countdownPaused = false;
	};

	/**
	 * @param {Number} elapsed
	 */
	p.update = function(elapsed)
	{
		if (_countdownPaused === false)
		{
			_countdownTime = Math.max(0, _countdownTime - elapsed);
		}
	};

	/**
	 * Return a powerup segment from config
	 * @param{Boolean}isHealthFull True if we have all our seeds -
	 * used to say not to send back 'life' if we have full health
	 * @return {Object} A object with the powerups config data
	 */
	p.getSegment = function(isHealthFull)
	{
		if (_countdownTime > 0 || _countdownPaused)
			return false;

		var choice = null;
		while (choice === null)
		{
			choice = _powerupsList.random();
			// if health is full, don't let the random the life powerup, and reroll
			if (choice == Powerup.Life && isHealthFull)
			{
				choice = null;
			}
		}

		_countdownPaused = true;
		// Query override the choice or get its name
		choice = (DebugOptions.powerup || choice.name).toLowerCase();
		if (Debug)
		{
			this.count = this.count + 1 || 1;
		}
		//segment adding expects an array due to the original way the config for level-chunks were setup. 
		return _powerupSegments[choice];
	};

	namespace("nature").PowerupManager = PowerupManager;

}());
